export { TimepickerConfig } from './timepicker.config';
export { TimepickerComponent } from './timepicker.component';
export { TimepickerModule } from './timepicker.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/timepicker/index.js
// module id = 592
// module chunks = 5